import { supportedLocales, rollupLocales } from "./supportedLocales";

export { regionLocaleLangs } from "./supportedLocales";

export const intlConfig = {
  fallbackLocale: 'en',
  globalLocale: 'global',
  supportedLocales,
  rollupLocales,
};

export default intlConfig;